export default "__VITE_PUBLIC_ASSET__52b8e079__"